import { useMutation } from '@tanstack/react-query'
import { ErrorCodeEnum, UsersApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import {
  handleHTTPError,
  HTTPError,
  isHTTPError,
} from 'src/state/middleware/saga/handleHttpError'

export type ValidateDeleteUserGroupParams = {
  userGroupId: number
}

export type ValidateDeleteUserGroupResult = {
  canDelete: boolean
  errorMessage?: string
}

export const useMutationValidateDeleteUserGroup = () => {
  return useMutation({
    mutationFn: async (
      params: ValidateDeleteUserGroupParams,
    ): Promise<ValidateDeleteUserGroupResult> => {
      try {
        await baseClient
          .getApi(UsersApi)
          .validateDeleteUserGroup({
            userGroupId: params.userGroupId,
          })
          .catch(handleHTTPError)
        return { canDelete: true }
      } catch (error) {
        if (isHTTPError(error)) {
          const httpError = error as HTTPError
          if (
            httpError.status === 400 &&
            httpError.code === ErrorCodeEnum.CannotDeleteUserGroupByImproveError
          ) {
            return {
              canDelete: false,
              errorMessage: httpError.errors.join('\n'),
            }
          }
        }
        throw error
      }
    },
  })
}
